export default "__VITE_ASSET__DBm1wYyz__"